import { sendTeacherAmplitudeEvent } from '../amplitude';
import { EventTypes } from '../types';
import { EventAdapter } from './EventAdapter';

interface ExportAnswerKeyEventData {
  library: 'personal' | 'shared';
  action: 'open' | 'click';
  source: 'quiz_menu' | 'export_button';
}

export class ExportAnswerKeyEventAdapter extends EventAdapter<ExportAnswerKeyEventData> {
  protected intercomEventKey = 'download-answer-key-library';
  protected amplitudeEventFunction = function sendDownloadAnswerKeyEvent(
    event: ExportAnswerKeyEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.DownloadAnswerKey, event);
  };

  constructor(props: {
    library: 'personal' | 'shared';
    action: 'open' | 'click';
    source: 'quiz_menu' | 'export_button';
  }) {
    super();

    try {
      this.eventData = {
        library: props.library,
        action: props.action,
        source: props.source,
      };
    } catch (err) {
      console.error('Error parsing analytics data for export answer key', err);
    }
  }
}
